import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { ErrorMessage, Spinner } from "app/components";
import { useParams } from "react-router-dom";
import { empresasService } from "app/services";

const FormatosContext = createContext();

export function FormatosProvider({ children }) {
  const params = useParams();

  const formatosQuery = useQuery({
    queryKey: ["empresa:get:formatos", params.empresa_id],
    queryFn: () =>
      empresasService.getFormatos({
        empresaId: params.empresa_id,
      }),
  });

  if (!!formatosQuery.isLoading) {
    return <Spinner label="Cargando los formatos..." />;
  } else if (!!formatosQuery.isError) {
    return <ErrorMessage message={formatosQuery.error.response.statusText} />;
  }

  return (
    <FormatosContext.Provider
      value={{
        formatos: formatosQuery.data,
        isLoading: formatosQuery.isLoading,
        isFetching: formatosQuery.isFetching,
        isRefetching: formatosQuery.isRefetching,
      }}
    >
      {children}
    </FormatosContext.Provider>
  );
}

export function useFormatosContext() {
  const formatosContext = useContext(FormatosContext);

  if (!formatosContext) {
    throw new Error(
      "useFormatosContext should be used inside the FormatosProvider."
    );
  }

  return formatosContext;
}
